import { NamedComplexEnumItem } from './NamedComplexEnumItem'

export class DetailedComplexEnumItem<
  ID extends Lowercase<string> = Lowercase<string>,
  Name extends string = string
> extends NamedComplexEnumItem<ID, Name> {
  get fullName() {
    return `${this.name} - ${this.description}` as const
  }
  /**
   * an extended description to describe the enum in CIMS
   */
  readonly description: string
  /**
   * @see {@link NamedComplexEnumItem}
   */
  constructor({
    description,
    ...simple
  }: Pick<DetailedComplexEnumItem<ID, Name>, 'id' | 'name' | 'description'>) {
    super(simple)
    this.description = description
  }
}
